import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.css";
import ContactForm from "../../../../COMPONENTS/FORM/CONTACT";
import AOS from "aos";
import "aos/dist/aos.css";

const ContactSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="contact-section">
      <Container>
        <Row className="align-columns">
          <Col xs={12} className="text-center mb-4">
            <h2 className="contact_title" data-aos="fade-up">
              Contact Us
            </h2>
          </Col>
        </Row>

        <Row>
          <Col xs={10} md={6} className="order-md-1" data-aos="fade-right">
            <ContactForm />
          </Col>

          <Col xs={12} md={6} className="order-md-2" data-aos="fade-left">
            <div className="text-left">
              <div data-aos="fade-in" className="subtext">
                Collaborate directly with physicians. KUR Diagnostics to integrate
                diagnostic programs that enhance clinical efficiency and
                preventive care delivery. <br />
                For partnership inquiries or service information, please
                contact us at{" "}
                <a href="mailto:info@kurdiagnostics.com" className="highlight">
                  info@kurdiagnostics.com
                </a>{" "}
                or call{" "}
                <a href="tel:+18663005380" className="highlight">
                  +1 (866) 300-5380
                </a>

                <span className="subtext mt-4"></span>
              </div>

              <div className="subtext mt-4" data-aos="fade-in"></div>

              <address data-aos="fade-in" className="mt-4">
                <strong>Clinic Support Center</strong>
                <span className="subtext">
                  <br />
                  2425 Cedar Springs Road
                  <br />
                  Dallas, Texas 75201
                  <br />
                  United States
                  <br />
                </span>
              </address>

              <div data-aos="fade-in" className="mt-4"></div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactSection;